import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'

import { setProject } from '../../obj/pscState'

import DependingObjects from '../../components/psc/lib/DependingObjects'
import CancelButton from '../../components/psc/lib/CancelButton'
import SaveButton from '../../components/psc/lib/SaveButton'
import DeleteButton from '../../components/psc/lib/DeleteButton'
import ErrorMessage from '../../components/psc/lib/ErrorMessage'
import HasTemplate from '../../components/psc/lib/HasTemplate'
import SingleSelect from '../../components/psc/lib/SingleSelect'
import Loading from '../../components/psc/lib/Loading'

import useCadmObject from '../../hooks/useCadmObject'

const StdDocument = () => {
    let { objID } = useParams()
    const isNew = objID === "new" ? true : false
    objID = parseInt(objID,10)
    const objectUrl = '/v0/std_documents' + (isNew ? '' : '/' + objID)

    const dispatch = useDispatch()
    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project
    
    const {
        cadmObjects
    } = useCadmObject()

    // Fields
    const [name, setName] = useState('')
    const [cadmObjectID, setCadmObjectID] = useState(0)
    
    // Read-only
    const [isUsed, setIsUsed] = useState(false)
    const [dependingObjects, setDependingObjects] = useState([])
    const [template, setTemplate] = useState({})

    // Submit
    const [submitActive, setSubmitActive] = useState(false)
    const [error, setError] = useState(null)
    const [hasLoaded, setHasLoaded] = useState(isNew ? true: false)

    useEffect(() => {
        if ( ! isNew) {
            fetchObject()
        }
    }, [isNew])

    const fetchObject = () => {
        fetch(objectUrl, { credentials: 'same-origin' })
            .then(function(response) {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error(response.statusText)
                }
            })
            .then(function(json) {
                if(json.error) {
                    throw new Error(json.error)
                }

                fromBackend(json.result)
            })
            .catch(function(error) {
                console.log(error)
            })
    }

    const fromBackend = (obj) => {
        setName(obj.name)
        setCadmObjectID(obj.cadm_object_id)
        setIsUsed(obj.is_used)
        setDependingObjects(obj.depending_objects)
        setTemplate(obj.template)
        setHasLoaded(true)
    }

    const toBackend = () => {
        return {
            name: name.trim(),
            cadm_object_id: cadmObjectID,
        }
    }

    const validateBeforeSubmit = () => {
        let errors = []
        if ( ! name ) {
            errors.push('Type is required')
        }

        if ( ! cadmObjectID ) {
            errors.push('Configured Item is required')
        }

        if ( errors.length > 0 ) {
            setError(errors)
            return false
        }

        return true
    }

    const handleSubmitError = (props) => {
        setSubmitActive(false)
        setError([ props.message ])
    }
    
    const handleSubmit = (event) => {
        if( event ) {
            event.preventDefault()
        }
        if( submitActive || !validateBeforeSubmit() ) {
            return null
        }

        setSubmitActive(true)

        return {
            objType: 'std_documents',
            objID: objID,
            data: toBackend(),
            successCallback: function() {
                // This is only to update the current users cache of their current project.
                if( project && project.id && project.id > 0 ) {
                    fetch('/v0/projects/' + project.id, { credentials: 'same-origin' })
                        .then(function(response) {
                            if (!response.ok) throw response
                            return response.json()
                        })
                        .then(function(json) {
                            if (json.error) {
                                return
                            }
                            console.log("Cadm/StdDocument is updating the current project");
                            dispatch(setProject(json.result))
                        })
                        .catch(error => console.log("Cadm/StdDocument Get Project error", error))
                }
            }
        }
    }

    let requiredIndicator = (<label className="form-required-star">&nbsp;*</label>);

    if (!hasLoaded) {
        return <Loading />
    }
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Portfolio Document Type: {name || '<New Portfolio Document Type>'}</h2>
                        </div>
                        <div className="ibox-content">
                            <form className="form-horizontal" onSubmit={(e) => handleSubmit(e)}>
                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Type
                                        {requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required 
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Configured Item
                                        {requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <SingleSelect
                                            value={cadmObjectID}
                                            onChange={object => setCadmObjectID(object.id)}
                                            options={cadmObjects}
                                            required={true}
                                            disabled={isUsed}
                                        />
                                    </div>
                                </div>

                                <HasTemplate
                                    templateID={template.id}
                                    filename={template.filename}
                                    disabled={false}
                                    visible={true}
                                />

                                <div className="hr-line-dashed"></div>

                                <div className="form-group">
                                    <ErrorMessage
                                        error={error}
                                    />

                                    <div className="col-sm-10 col-sm-offset-2">
                                        <CancelButton />
                                        
                                        <SaveButton
                                            buttonVariant='primary'
                                            visible={true}
                                            spinnerActive={submitActive}
                                            label='Save Changes'
                                            onClick={handleSubmit}
                                            onError={handleSubmitError}
                                        />

                                        <DependingObjects list={dependingObjects} />

                                        <DeleteButton
                                           isHidden={isNew || isUsed}
                                           url={objectUrl}
                                           onError={handleSubmitError}
                                        />

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default StdDocument
